import { render, staticRenderFns } from "./MailTemplateEdit.vue?vue&type=template&id=55faf7a4&scoped=true&"
import script from "./MailTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./MailTemplateEdit.vue?vue&type=script&lang=js&"
import style0 from "./MailTemplateEdit.vue?vue&type=style&index=0&id=55faf7a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55faf7a4",
  null
  
)

export default component.exports